import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'No puedo creer la diferencia. Mi pareja no para de agradecerme, dice que nunca experimentó algo igual. ¡Me siento súper poderosa!',
    name: 'Valentina R.',
    rating: 5
  }, {
    quote: 'Al principio tenía vergüenza, pero las técnicas son tan claras que enseguida me sentí segura. Los resultados fueron inmediatos.',
    name: 'Camila M.',
    rating: 5
  }, {
    quote: 'Lo mejor que compré en mucho tiempo. Las guías son increíbles y los bonos valen oro. La comunidad VIP es hermosa y de mucho apoyo.',
    name: 'Luciana P.',
    rating: 5
  }, {
    quote: 'Mi relación cambió completamente. Estábamos en la rutina y esto encendió la chispa de nuevo. Recomiendo 100% a todas.',
    name: 'Sofía G.',
    rating: 5
  }];
  return <section className="py-24 bg-[#1A0230] relative px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-176">
      {/* Background text watermark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-black text-white/[0.02] whitespace-nowrap pointer-events-none select-none z-0" data-id="element-177">
        EXPERTAS
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4 uppercase tracking-tight" data-id="element-180">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF2D8A] to-[#FFD700]" data-id="element-181">
              PROBADO Y APROBADO
            </span>
            <br data-id="element-182" />
            por cientos de alumnas dedicadas
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-183">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-3xl shadow-xl hover:bg-white/15 transition-colors" data-id="element-184">
              <div className="flex gap-1 mb-6" data-id="element-185">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-186" />)}
              </div>
              <p className="text-lg text-gray-200 mb-6 italic leading-relaxed" data-id="element-187">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-188">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#FF2D8A] to-[#9D00FF] flex items-center justify-center text-white font-bold text-xl" data-id="element-189">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-190">
                  <p className="text-white font-bold" data-id="element-191">{testimonial.name}</p>
                  <p className="text-sm text-gray-400" data-id="element-192">Alumna Verificada</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}